import React from 'react';

const QuotesIcon: React.SFC<{}> = () => (
    <svg height="45.751865" viewBox="0 0 41.8176 45.751865" width="41.8176">
        <g fill="none" stroke="currentColor" strokeMiterlimit="10" transform="matrix(1.3333333 0 0 -1.3333333 0 45.751867)">
            <path d="m0 0v-8.362c0-1.559-1.275-2.835-2.834-2.835h-19.402c-1.559 0-2.834 1.276-2.834 2.835v27.181c0 1.559 1.275 2.835 2.834 2.835h19.402c1.559 0 2.834-1.276 2.834-2.835v-11.39" strokeWidth="1.463" transform="translate(25.8019 11.9281)" />
            <g strokeWidth="1.4">
                <path d="m0 0-3.204 2.972-3.037-3.34 6.698-6.241 11.507 14.253-3.466 2.879z" transform="translate(18.4206 10.1791)" />
                <path d="m0 0h14.722" transform="translate(5.9059 27.5922)" />
                <path d="m0 0h14.722" transform="translate(5.9059 22.6171)" />
                <path d="m0 0h14.722" transform="translate(5.9059 17.6425)" />
            </g>
        </g>
    </svg>
);
export { QuotesIcon };
